import Vue from 'vue';
import Vuetify from 'vuetify';
import VueApollo from 'vue-apollo';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueGeolocation from 'vue-browser-geolocation';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';

// List of components
const AlertCmp = () => import('../components/Shared/Alert.vue');
const ToolbarCmp = () => import('../components/Shared/Toolbar.vue');
const CurrentCycle = () => import('../components/Device/Item/CurrentCycle.vue');
const DeviceMapPivot = () => import('../components/Device/Item/DeviceMapPivot.vue');
const Timeline = () => import('../components/Device/Item/Timeline.vue');
const DeviceActions = () => import('../components/Device/Item/DeviceActions.vue');
const SnackbarCmp = () => import('../components/Shared/Snackbar.vue');
const ComingSoonModal = () => import('../components/Shared/ComingSoonModal.vue');

export const VueRegister = () => {
  Vue.use(Vuetify);
  Vue.use(VueApollo);
  Vue.use(Datetime);
  Vue.use(VueGeolocation);
  Vue.use(VueGoogleMaps, {
    load: {
      key: process.env.VUE_APP_STATIC_MAP_API_KEY
    }
  });
  Vue.config.productionTip = false;
  Vue.prototype.$log = console.log;

  Vue.component('app-alert', AlertCmp);
  Vue.component('datetime', Datetime);
  Vue.component('app-toolbar', ToolbarCmp);
  Vue.component('current-cycle', CurrentCycle);
  Vue.component('device-map-pivot', DeviceMapPivot);
  Vue.component('timeline', Timeline);
  Vue.component('device-actions', DeviceActions);
  Vue.component('app-snackbar', SnackbarCmp);
  Vue.component('coming-soon-modal', ComingSoonModal);

  return Vue;
};



// WEBPACK FOOTER //
// ./src/lib/register.js